export default __webpack_public_path__ + "static/media/1ce585a08863f5b200deeec5042426ce.svg";